import { gridFilterActiveItemsLookupSelector } from "@mui/x-data-grid";
import { useSelector } from "react-redux";
import { scheduledataSelector } from "reducers/scheduledata/scheduledata";

export { todayLocaleDateString, calculateCurrentWeek, weekHasPendingChanges };

function weekHasPendingChanges(scheduleData) {

  /* let scheduleData = useSelector(scheduledataSelector);
  return false; */


  

  
  console.log("schedulehelper - weekHasPendingChanges", scheduleData);

  if (!scheduleData) return false;

  if (!scheduleData.selectedWeekNumber) return false;

  if (
    !scheduleData.menus ||
    !scheduleData.menus.hasOwnProperty(scheduleData.selectedWeekNumber)
  ) {
    return false;
  }

  console.log("schedulehelper - object ", scheduleData.menus);

  let hasUnsavedData = false;
  Object.keys(scheduleData.menus).map(key_week => {
    // loop through weeks
    Object.keys(scheduleData.menus[key_week]).map(key_day => {
      // loop through days
      console.log(
        "schedulehelper - obj ",
        scheduleData.menus[key_week][key_day]
      );
      if (scheduleData.menus[key_week][key_day].savedToSap == false) {
        console.log(
          "schedulehelper - has unsaved data",
          scheduleData.menus[key_week][key_day].savedToSap
        );
        hasUnsavedData = true;
        return true;
      }
    });
  });

  if (hasUnsavedData == true)
    console.error("schedulehelper I should not be here ", hasUnsavedData);

  return hasUnsavedData;
}


function calculateCurrentWeek(date) {
  //https://www.geeksforgeeks.org/calculate-current-week-number-in-javascript/
  const currentDate = 
      (typeof date === 'object') ? date : new Date();
  const januaryFirst = 
      new Date(currentDate.getFullYear(), 0, 1);
  const daysToNextMonday = 
      (januaryFirst.getDay() === 1) ? 0 : 
      (7 - januaryFirst.getDay()) % 7;
  const nextMonday = 
      new Date(currentDate.getFullYear(), 0, 
      januaryFirst.getDate() + daysToNextMonday);

  return (currentDate < nextMonday) ? 52 : 
  (currentDate > nextMonday ? Math.ceil(
 ((currentDate - nextMonday) / (24 * 3600 * 1000) / 7) + 1) : 1);
}

function todayLocaleDateString() {
  return new Date().toLocaleDateString();
}

